import { object } from '@gogame/schemas';

import { chartsSchema } from './chartsSchema';
import { columnsSchema } from './columnsSchema';
import { drillPathSchema } from './drillPathSchema';
import { filtersCollectionSchema } from './filtersSchema';
import { tableSettingsSchema } from './tableSettingsSchema';

export const presetSchema = object({
  filtersCollection: filtersCollectionSchema,
  tableSettings: tableSettingsSchema,
  charts: chartsSchema,
  columns: columnsSchema,
  drillPath: drillPathSchema,
});

export const mapStateToPreset = (screenState) =>
  presetSchema.stripDefaults().cast(screenState, {
    applyConst: true,
    stripUnknown: true,
  });
